import { KEYS, readJSON, writeJSON } from './storage'

/* 'all' | 'necessary' | null (not asked yet). */
export function readConsent() {
  const value = readJSON(KEYS.consent, null)
  return value === 'all' || value === 'necessary' ? value : null
}

export function saveConsent(value) {
  writeJSON(KEYS.consent, value)
}

/* AdSense serves non-personalised ads unless the reader accepted all. Must
   run before the first ad request. */
export function applyAdConsent(value = readConsent()) {
  window.adsbygoogle = window.adsbygoogle || []
  window.adsbygoogle.requestNonPersonalizedAds = value === 'all' ? 0 : 1
}
